const headers = [
    { text: "Codigo", value: "id", width: "70px" },
    { text: "Descrição", value: "description_pdv" },
    { text: "Referencia", value: "reference", width: "90px" },
    { text: "Preço", value: "sale_price", width: "120px" },
    { text: "Ações", value: "actions", width: "64px", sortable: false },
];

export { headers };
